(function () {
  'use strict';

  angular.module('wsLrs.services').factory("SettingsDropdownLinks", ['$rootScope', 'UserRoles', 'User', 'wsEventNames', 'OrganizationSettings', function ($rootScope, UserRoles, User, wsEventNames, OrganizationSettings) {
    return {
      get: function get(context) {
        var user = User.get(),
          isOrgAdmin = UserRoles.isOrgAdmin(user),
          isOrgManager = UserRoles.isOrgManager(user),
          exposeYourAccountLink = !user.isExternallyIdentified,
          exposeYourOrganizationLink = UserRoles.isWatershedUser(user) && isOrgManager && OrganizationSettings.hasFeature('editOrganizationPeopleAndGroups'),
          exposeUsersLink = isOrgManager,
          exposeAppearanceLink = isOrgAdmin,
          exposeViewDashboardsAs = UserRoles.isViewDashboardsAsAllowed(user) && context !== 'settings' && OrganizationSettings.hasFeature('viewDashboardAs'),
          exposeCards = UserRoles.isOrgAdmin(user) && OrganizationSettings.getSettingsSync().pricingTier !== 'ESSENTIALS',
          exposePermissionsLink = isOrgAdmin && OrganizationSettings.hasFeature('basicExplorer'),
          exposeDashboardsLink = isOrgManager && OrganizationSettings.hasFeature('multipleDashboards'),
          exposeMeasureEditor = isOrgManager && OrganizationSettings.hasFeature('measureEditor'),
          exposeFilterEditor = isOrgManager && OrganizationSettings.hasFeature('filterEditor'),
          exposeCredlyBadges = isOrgAdmin && OrganizationSettings.hasFeature('credlyBadges');
        var canAccessWorkflows = isOrgAdmin && OrganizationSettings.hasFeature('workflows');
        var exposeSharesLink = isOrgAdmin;
        return [{
          href: "#/settings/your-account",
          condition: exposeYourAccountLink,
          section: 'your-account',
          display: 'Your Account'
        }, {
          href: "#/settings/your-organization",
          condition: exposeYourOrganizationLink,
          section: 'your-organization',
          display: 'Your Organization'
        }, {
          href: "#/settings/users",
          condition: exposeUsersLink,
          section: 'users',
          display: 'Watershed Users'
        }, {
          href: "#/settings/appearance",
          condition: exposeAppearanceLink,
          section: 'appearance',
          display: 'Appearance'
        }, {
          href: '#/settings/measures',
          condition: exposeMeasureEditor,
          section: 'measures',
          display: 'Measures'
        }, {
          href: '#/settings/filters',
          condition: exposeFilterEditor,
          section: 'filters',
          display: 'Filters'
        }, {
          href: '#/settings/badges',
          condition: exposeCredlyBadges,
          section: 'badges',
          display: 'Credly Badges'
        }, {
          href: "#/settings/explore-access",
          condition: exposePermissionsLink,
          section: 'explore-access',
          display: 'Report Builder'
        }, {
          href: "#/settings/dashboards",
          condition: exposeDashboardsLink,
          section: 'dashboards',
          display: 'Dashboards'
        }, {
          href: "#/settings/reports",
          condition: exposeCards,
          section: "reports",
          display: "Reports"
        }, {
          href: "",
          condition: exposeViewDashboardsAs,
          display: 'View Dashboards As',
          click: function click() {
            $rootScope.$broadcast(wsEventNames.viewDashboardsAs.show, true);
          }
        }, {
          href: "#/settings/workflows",
          condition: canAccessWorkflows,
          display: 'Workflows',
          section: 'workflows'
        }, {
          href: "#/settings/shares",
          condition: exposeSharesLink,
          section: "shares",
          display: "Shares"
        }];
      }
    };
  }]);
})();
